export const views = {
    MENU: "menu",
    NEW: "new",
    INBOX: "inbox",
    SENT: "sent",
    TRASH: "trash",
    MAIL: "mail"
}